var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h18l7.5 8.625V35.5A1.5 1.5 0 0 1 29 37H5a1.5 1.5 0 0 1-1.5-1.5V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    stroke: "#888D96",
    strokeWidth: 0.75,
    d: "M8 .625h17.83l7.295 8.39V33.25c0 .621-.504 1.125-1.125 1.125H8a1.125 1.125 0 0 1-1.125-1.125V1.75c0-.621.504-1.125 1.125-1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M7.25 22.5h19.63v3.75a1.5 1.5 0 0 1-1.5 1.5H7.25V22.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 14,
    x: 0.88,
    y: 12.25,
    fill: "#888D96",
    rx: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.971 22.38v-6.363h4.14v.958h-2.997v1.74h2.777v.958h-2.777v1.74h3.014v.967h-4.157ZM13.102 22.38v-6.363h1.143v5.396h2.812v.967h-3.955ZM11.916 16.017v6.363h-1.143v-6.363h1.143ZM5.728 22.38v-6.363h4.078v.958H6.871v1.74h2.654v.958H6.871v2.707H5.728Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M26 .25v8.625h7.5L26 .25Z"
  })));
};
export default SvgFile;